import React, { useState,useEffect } from "react";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
const Debugoutput = (props) => {
  function toRadians(angle) {
    return angle * (Math.PI / 180);
  }
  function toDegree(radian) {
    return radian * (180 / Math.PI);
  }
  const [uservariables, setUserVariables] = useState([]);
  useEffect(() => {
    let D = parseInt(props.dimensions.direction);
    let length = parseInt(props.dimensions.endrd - props.dimensions.startrd);
    let height = parseInt(props.dimensions.height);
    let width = parseInt(props.dimensions.width);
    let hw = parseInt(props.dimensions.hw);
    let WS = parseInt(props.dimensions.widthspl);
    let P2 = parseInt(props.dimensions.p2);
    let P4 = parseInt(props.dimensions.p4);
    let P5 = parseInt(props.dimensions.p5);
    let Whalf = WS / 2;
    let HC = height - hw;
    let r = (Math.pow(Whalf, 2) + Math.pow(HC, 2)) / (2 * HC);
    let Theta = toDegree(Math.atan((r - HC) / Whalf));
    let n = Theta;
    let Hn = r*Math.sin(toRadians(90));
    let usrvar = [],TanAlpha,Pmid,Beta,ApDir,Dir,Alpha;
    
    // usrvar['Whalf'] = Whalf;
    // usrvar['HC'] = HC;
    // usrvar['R'] = r;
    // usrvar['Theta'] = Theta;
    // usrvar['n'] = n;
    // usrvar['Hn'] = Hn;
    if(P2>P4)
    {
      TanAlpha=WS/(P2-P4);
      Pmid=P4+(P2-P4)/2;
      Beta=toDegree(Math.atan(Hn/(Pmid-P5)));
    }
    else
    {
      TanAlpha=WS/(P4-P2);
      Pmid=P2+(P4-P2)/2;
      Beta=toDegree(Math.atan(Hn/(P5-Pmid)));
    }
     Alpha = toDegree(Math.atan(TanAlpha));  
    if(Pmid>P5)
    {
      ApDir=D;
    }
    else
    {
      ApDir=D-180;
    }
    if(ApDir>360)
    {
      ApDir=ApDir-360;
    }
   if( Pmid>P4)
   {
    Dir=ApDir-(90-Alpha);
   }
   else
   {
    Dir=ApDir+(90-Alpha);
   }
   if(Dir<0)
   {
    Dir=360+Dir
   }
   if(Dir>360)
   {
    Dir=Dir-360
   }
   let Dirstring = String(Math.round(Dir)).padStart(3, '0');
   
    let TanAmt=Math.tan(toRadians(Beta))/Math.sin(toRadians(Alpha));
    let Amt = toDegree(Math.atan(TanAmt));
    let Amtstring = String(Math.round(Amt)).padStart(2, '0');
  
    
    // usrvar['WS'] = WS;
    usrvar['Discontinuity Dip'] = "N"+Dirstring+"/"+Amtstring;
    usrvar['P2'] = P2;
    usrvar['P4'] = P4;
    usrvar['P5'] = P5;
    usrvar['Pmid'] = Pmid;
    usrvar['Alpha'] = Math.round(Alpha);
    usrvar['Beta'] = Math.round(Beta);
    usrvar['ApDir'] = ApDir;
    // usrvar['Dirval'] = Dir;
    usrvar['Dir'] = Dirstring;
    // usrvar['Amtval'] = Amt;
    usrvar['Amt'] = Amtstring;
    setUserVariables(usrvar);
  }, []);
  
  return (
    <div id="page">
    <Header />
    <Footer />
    <div className="page-content header-clear-medium">
      <div className="card card-style contact-form">
        <div className="content">
        <button onClick={()=>{props.showinput()}} className="btn bg-green-dark mw-2 me-3">Go Back</button> 
          <table className="table">
            <tbody>
              {Object.keys(uservariables).map((uservariable) => (
                <tr>
                  <td>{uservariable}</td>
                  <td>{uservariables[uservariable]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
     
     
     
    </div>
    </div>
  );
};

export default Debugoutput;
